/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountCostRecommendationSettings {
    getFixupPrototypeFunction() { return MasterAccountCostRecommendationSettings.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountCostRecommendationSettings>): MasterAccountCostRecommendationSettings {
        let obj = Object.assign(new MasterAccountCostRecommendationSettings(), model);
        MasterAccountCostRecommendationSettings.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountCostRecommendationSettings>): MasterAccountCostRecommendationSettings {
        if (!model) return null;
        return MasterAccountCostRecommendationSettings.newInstance(<MasterAccountCostRecommendationSettings> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountCostRecommendationSettings) {
        if (!obj) return;

        models.MasterAccountCostRecommendationSettings.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountCostRecommendationSettings): boolean {
        Object.setPrototypeOf(obj, MasterAccountCostRecommendationSettings.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the product
     */
    product: models.ProductEnum;

    /**
     * Enable/Disable cloud native recommendation sync for the product
     */
    cloud_native_recommendation_sync_enabled: boolean;

}
